import { getJson, putJson, deleteJson } from "./ServiceHelperMethods";

class MCPService {

    static async getMcps(workspaceId) {
        const qs = workspaceId ? `?workspaces=${encodeURIComponent(workspaceId)}` : '';
        return await getJson(`mcps${qs}`);
    }

    static async getMcp(mcpId) {
        return await getJson(`mcps/${mcpId}`);
    }

    static async putMcps(mcps) {
        return await putJson(`mcps`, mcps);
    }

    static async deleteMcp(mcpId) {
        return await deleteJson(`mcps/${mcpId}`);
    }
}

export default MCPService;
